<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

            <div class="col-12">
                <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Laporan Stok Barang</h5>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="createLapStok()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tanggal : </label>
                            <datepicker v-model="akhir" :disabledDates="disabledAkhir" name="tgl_akhir" :format="format" placeholder="Tanggal Akhir"></datepicker>
                            <has-error :form="form" field="tanggal"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-success fas fa-file-excel"> Ekspor</button>
                        <button type="button" @click="createLapStokAll" class="btn btn-secondary fas fa-file-excel" v-if="$gate.isAdmin1()"> Per Unit Kerja</button>
                    </div>
                  </form>
                </div>
            </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        data () {
            return {
                defaultDate: '2022-01-01',
                DatePickerFormat: 'yyyy',
                editmode: false,
                adjustments : {},
                tahun: '',
                format: 'yyyy-MM-dd',
                akhir:'',
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                form: new Form({
                    id : ''                    
                })
            }
        },
        methods: {            
            createLapStok(){
                let offset = this.akhir.getTimezoneOffset();
                let akhirDate = new Date(this.akhir.getTime() - (offset*60*1000));
                //let routeData = this.$router.resolve({ path: "/lapstoktglxls" , query: {akhir: akhirDate.toISOString().split('T')[0], unit_kerja:'opd'}});
                //window.open(routeData.href, '_blank');
				
				axios.get('api/lapstoktglxls?akhir=' + akhirDate.toISOString().split('T')[0] + '&unit_kerja=opd',
                        {responseType: 'blob'})
                    .then(response => {
                            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', 'stoktanggal-'+akhirDate.toISOString().split('T')[0]+'.xlsx');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                        })
            },
            createLapStokAll(){
                let offset = this.akhir.getTimezoneOffset();
                let akhirDate = new Date(this.akhir.getTime() - (offset*60*1000));
                //let routeData = this.$router.resolve({ path: "/lapstoktglxls" , query: {akhir: akhirDate.toISOString().split('T')[0], unit_kerja:'uk'}});
                //window.open(routeData.href, '_blank');
				
				axios.get('api/lapstoktglxls?akhir=' + akhirDate.toISOString().split('T')[0] + '&unit_kerja=uk',
                        {responseType: 'blob'})
                    .then(response => {
                            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', 'stoktanggalall-'+akhirDate.toISOString().split('T')[0]+'.xlsx');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                        })
            },
            setYear(date) {                
                alert(date);
                let d=new Date(date);
                this.tahun=d.getFullYear;
                alert(this.tahun);
            }
        },
        mounted() {
            //let d=new Date();
            //this.tahun=d.getFullYear;
            this.tahun= new Date().getFullYear() ;
            console.log('Component mounted.')
        },
        created() {
            
        },
        components: {
            Datepicker
        }
    }
</script>